import { Navigate, useLocation } from 'react-router-dom';
import { RETURN_TO_PARAM, safeReturnTo } from '@/utils/returnTo';

const KEPT_ON_INDEX_REDIRECT = ['newMembers', 'member'];

/**
 * "/" once signed in: back to where the visitor was heading (returnTo), otherwise Study.
 * The New Members links (/?newMembers=1&member=...) keep their query so the tray opens.
 */
export function IndexRedirect() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const returnTo = safeReturnTo(params.get(RETURN_TO_PARAM));
  if (returnTo) return <Navigate to={returnTo} replace />;

  // Keep only the New Members link parameters; sign-in leftovers (oobCode, apiKey...) stay behind.
  const keep = new URLSearchParams();
  for (const key of KEPT_ON_INDEX_REDIRECT) {
    const value = params.get(key);
    if (value !== null) keep.set(key, value);
  }
  const rest = keep.toString();
  return <Navigate to={rest ? `/study?${rest}` : '/study'} replace />;
}
